module.exports = __webpack_public_path__ + "img/box7-img-5.ada1ece1.png";